module.exports = __webpack_public_path__ + "static/img/xg4.1fd7aba7.png";